import { breakingNews, headlineStory } from "@/mocks/baoliao";

function BreakingTicker() {
  const items = breakingNews.map((n) => n.title);
  const doubled = [...items, ...items];
  return (
    <div className="border-y border-foreground-200 bg-foreground-950 text-background-50 overflow-hidden">
      <div className="mx-auto flex max-w-7xl items-center px-4 md:px-6 py-2.5">
        <div className="flex items-center gap-2 pr-3 shrink-0 border-r border-background-50/20 mr-3">
          <span className="inline-flex w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot" />
          <span className="text-sm font-bold tracking-wide whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
            快讯滚动
          </span>
        </div>
        <div className="relative overflow-hidden flex-1">
          <div className="flex gap-12 whitespace-nowrap animate-marquee w-max">
            {doubled.map((title, i) => (
              <span key={i} className="text-sm text-background-100 inline-flex items-center gap-2">
                <i className="ri-fire-fill text-accent-400 text-xs" />
                {title}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="headline" className="relative scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        {/* 页眉标题 */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-8">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 text-accent-800 px-3 py-1 text-xs font-medium">
              <i className="ri-flashlight-fill" />
              今日头条 · 全网首发
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl text-foreground-950 leading-tight">
              一手猛料，<span className="text-primary-600">先人一步</span>看到真相
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            从内部流出到绝密文件，呱呱爆料把每一条待确认线索梳理给你，和你在吃瓜路上一起逼近事件源头。
          </p>
        </div>

        {/* 头条主视觉 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
          {/* 左主头条 */}
          <article className="lg:col-span-8 group relative overflow-hidden rounded-xl bg-background-50">
            <a href="#feed" className="block relative h-[380px] md:h-[440px]">
              <img
                src={headlineStory.img}
                alt={headlineStory.title}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
                <div className="flex items-center gap-2 mb-3">
                  <span className="inline-flex items-center gap-1 rounded-full bg-primary-600 px-2.5 py-0.5 text-xs text-background-50 whitespace-nowrap">
                    <i className="ri-lock-2-line" />
                    {headlineStory.tag}
                  </span>
                  <span className="text-xs text-background-100/90">{headlineStory.time}</span>
                </div>
                <h3 className="text-xl md:text-3xl text-background-50 leading-snug font-bold">
                  {headlineStory.title}
                </h3>
                <p className="mt-2 hidden sm:block text-sm text-background-100/90 leading-relaxed max-w-2xl line-clamp-2">
                  {headlineStory.lead}
                </p>
              </div>
            </a>
          </article>

          {/* 右侧头条榜单 */}
          <div className="lg:col-span-4 flex flex-col gap-4">
            <div className="rounded-xl bg-background-50 p-5">
              <h4 className="text-lg text-foreground-950 mb-3 flex items-center gap-2">
                <i className="ri-flashlight-fill text-accent-500" />
                全网实时热议
              </h4>
              <div className="flex flex-col gap-3">
                {breakingNews.slice(0, 4).map((n, idx) => (
                  <a
                    key={n.id}
                    href="#feed"
                    className="group flex items-start gap-3 rounded-lg p-2 hover:bg-background-100 transition-colors"
                  >
                    <span className="inline-flex w-7 h-7 shrink-0 items-center justify-center rounded-md bg-primary-600 text-background-50 text-sm font-bold">
                      {idx + 1}
                    </span>
                    <div className="min-w-0">
                      <p className="text-sm text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                        {n.title}
                      </p>
                      <p className="text-xs text-foreground-500 mt-1">{n.time}</p>
                    </div>
                  </a>
                ))}
              </div>
            </div>
            <a
              href="#tip"
              className="group rounded-xl bg-accent-500 p-5 text-background-50 hover:bg-accent-600 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex w-9 h-9 items-center justify-center rounded-lg bg-background-50/20 text-xl">
                  <i className="ri-megaphone-line" />
                </span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
              </div>
              <p className="mt-3 text-base font-bold">你掌握独家线索？</p>
              <p className="text-sm text-background-50/90 mt-1">提交给呱呱爆料，让真相被更多人看到。</p>
            </a>
          </div>
        </div>
      </div>
      <BreakingTicker />
    </section>
  );
}